import { UserButton } from "@clerk/clerk-react";
import { Radius, Settings, Wallet } from "lucide-react";
import { Link, useNavigate } from "react-router";


export default function Navbar() {
    const navigate = useNavigate();

    return (
        <div className="navbar bg-base-100 mr-4">
            <div className="navbar-start">
                <Link className="flex flex-row items-center space-x-2 text-xl" to="/">
                    <Radius />
                    <span>ArcRadius</span>
                </Link>
            </div>
            <div className="navbar-end mr-4">
                <UserButton>
                    <UserButton.MenuItems>
                        <UserButton.Action
                            label="Subscription"
                            labelIcon={<Wallet size={16} />}
                            onClick={() => navigate('/subscription')}
                        />
                        <UserButton.Action
                            label="User Settings"
                            labelIcon={<Settings size={16} />}
                            onClick={() => navigate('/settings')}
                        />
                    </UserButton.MenuItems>
                </UserButton>
            </div>
        </div>
    )
}